export default function updateMetaTagEnding(property, newValue) {
    const metaTag = $(`meta[property="${property}"]`);

    if (metaTag.length === 0) {
        return;
    }

    let content = metaTag.attr('content');
    let value = content.substring(0, content.indexOf('|') + 2) + newValue;
    metaTag.attr('content', value);
}